import * as React from 'react';

// Define a default UI for filtering
export const DefaultColumnFilter = ({
  column: { filterValue, preFilteredRows, setFilter },
}) => {
  const count = preFilteredRows.length
  const isActive = filterValue !== undefined && filterValue !== '';

  return (
    <input
      value={filterValue || ''}
      onChange={e => {
        setFilter(e.target.value || undefined) // Set undefined to remove the filter entirely
      }}
      placeholder={`Search ${count} records...`}
      style={{
        backgroundColor: isActive ? '#e6f2ff' : undefined,
        border: isActive ? '2px solid #007bff' : '1px solid #ccc',
        borderRadius: '4px',
        padding: '4px',
        boxSizing: 'border-box'
      }}
    />
  )
}